import Icon from '../components/Icon.vue'

Icon.register({"notes-medical":{"width":384,"height":512,"paths":[{"d":"M336 64H256C256 28.7 227.3 0 192 0S128 28.7 128 64H48C21.5 64 0 85.5 0 112V464C0 490.5 21.5 512 48 512H336C362.5 512 384 490.5 384 464V112C384 85.5 362.5 64 336 64zM192 40C205.3 40 216 50.7 216 64S205.3 88 192 88 168 77.3 168 64 178.7 40 192 40zM288 344C288 348.4 284.4 352 280 352H224V408C224 412.4 220.4 416 216 416H168C163.6 416 160 412.4 160 408V352H104C99.6 352 96 348.4 96 344V296C96 291.6 99.6 288 104 288H160V232C160 227.6 163.6 224 168 224H216C220.4 224 224 227.6 224 232V288H280C284.4 288 288 291.6 288 296V344zM288 152C288 156.4 284.4 160 280 160H104C99.6 160 96 156.4 96 152V136C96 131.6 99.6 128 104 128H280C284.4 128 288 131.6 288 136V152z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/notes-medical.js
// module id = null
// module chunks = 